<!--page-wrapper Start-->
<div class="main-wrapper full-wrapper" style="height: 100vh">
  <router-outlet></router-outlet>
</div>
<!--page-wrapper Ends-->
